import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { SelectionType } from './GpsRouteSelectionType';
import { MIN_ALLOWABLE_DISTANCE_TO_ACCEPT } from '../../../actions/gps';
import { MAX_GPS_DISTANCE, MIN_GPS_DISTANCE } from '../constants';

export const useGpsSetting = () => {
    const routesDeclaration = useSelector((state) => get(state, 'routesDeclaration', {}));
    const allowedDistance = routesDeclaration.allowedDistance || MIN_ALLOWABLE_DISTANCE_TO_ACCEPT;
    const selectionType = routesDeclaration.selectionType || SelectionType.CURRENT;

    const [gps, changeGpsState] = useState({
        allowedDistance,
        selectionType,
    });

    const handleChangeSlider = useCallback((event, value) => changeGpsState((prevState) => ({ ...prevState, allowedDistance: value })), []);

    const handleChangeSelectionType = useCallback(
        (event, value) => changeGpsState((prevState) => ({ ...prevState, selectionType: +value })),
        []
    );

    const handleSliderUp = useCallback(() => {
        changeGpsState((prevState) => {
            const value = prevState.allowedDistance + 1 > MAX_GPS_DISTANCE ? MAX_GPS_DISTANCE : prevState.allowedDistance + 1;

            return { ...prevState, allowedDistance: value };
        });
    }, []);

    const handleSliderDown = useCallback(() => {
        changeGpsState((prevState) => {
            const value = prevState.allowedDistance - 1 < MIN_GPS_DISTANCE ? MIN_GPS_DISTANCE : prevState.allowedDistance - 1;

            return { ...prevState, allowedDistance: value };
        });
    }, []);

    return {
        gps,
        handleChangeSelectionType,
        handleChangeSlider,
        handleSliderDown,
        handleSliderUp,
    };
};
